import PrismicLink from '../PrismicLink/PrismicLink';
import Box from '../Box/Box';
import { Body2 } from '../Typography/Typography';
import { rem } from 'polished';
import React from 'react';
import { Link } from 'gatsby';

export const Tag = ({ tag, colorScheme = 'secondary', path }) => (
    <Box as={Link} to={`${path}/${tag.slug}`} display="inline-flex">
        <Box
            as={Body2}
            display="inline-flex"
            px={rem(8)}
            bg={`${colorScheme}.100`}
            color={`${colorScheme}.1600`}
            borderRadius="full"
            textTransform="capitalize"
            _hover={{
                backgroundColor: `${colorScheme}.200`,
                textDecoration: 'underline',
            }}
        >
            {tag.name}
        </Box>
    </Box>
);
